// Heat-loss calculator domain constants. Approximate linear heat-loss
// coefficients (W per metre per kelvin) for pre-insulated pipe by medium
// diameter (mm). These are editable engineering approximations — tune them to
// your real datasheet values; the calculator notes that figures are estimates.

export const GROUND_TEMP_DEFAULT = 10; // °C
export const HOURS_PER_YEAR_DEFAULT = 6000;
export const ENERGY_PRICE_DEFAULT = 0.12; // currency per kWh

export type HeatLossU = { diameter: number; single: number; duo: number };

export const HEAT_LOSS_U: HeatLossU[] = [
  { diameter: 20, single: 0.16, duo: 0.28 },
  { diameter: 25, single: 0.18, duo: 0.31 },
  { diameter: 32, single: 0.21, duo: 0.35 },
  { diameter: 40, single: 0.24, duo: 0.4 },
  { diameter: 50, single: 0.28, duo: 0.46 },
  { diameter: 63, single: 0.33, duo: 0.54 },
  { diameter: 75, single: 0.38, duo: 0.62 },
  { diameter: 90, single: 0.44, duo: 0.72 },
];

/** Nearest U-coefficient (W/m·K) for a diameter + type ("single"/"duo"). */
export function uForDiameter(diameter: number, duo: boolean): number {
  let best = HEAT_LOSS_U[0]!;
  for (const row of HEAT_LOSS_U) {
    if (Math.abs(row.diameter - diameter) < Math.abs(best.diameter - diameter)) best = row;
  }
  return duo ? best.duo : best.single;
}
